export type AmpelSchwellen = {
  gelbTage: number
  rotTage: number
}

export type Ampel = 'gelb' | 'rot'

export const DEFAULT_AMPEL_SCHWELLEN: AmpelSchwellen = { gelbTage: 7, rotTage: 14 }

// Calendar days avoid adding or losing a day across daylight-saving changes.
function localDayNumber(d: Date): number {
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86_400_000
}

export function tageInSpalte(seit: string | null | undefined, now: Date): number | null {
  if (!seit) return null
  const start = new Date(seit)
  if (Number.isNaN(start.getTime())) return null
  return Math.max(0, localDayNumber(now) - localDayNumber(start))
}

export function ampelFor(tage: number | null, schwellen: AmpelSchwellen): Ampel | null {
  if (tage === null) return null
  if (tage >= schwellen.rotTage) return 'rot'
  if (tage >= schwellen.gelbTage) return 'gelb'
  return null
}

export function isValidSchwellen(s: AmpelSchwellen): boolean {
  return Number.isInteger(s.gelbTage) && Number.isInteger(s.rotTage) && s.gelbTage >= 1 && s.rotTage > s.gelbTage
}
